// extracted by mini-css-extract-plugin
module.exports = {"main":"FullWidthDataTableStyles_main__1dnH2","graphHeader":"FullWidthDataTableStyles_graphHeader__2FhSC","scrollTable":"FullWidthDataTableStyles_scrollTable__2c7-m"};